<template>
    <div class="temp-collect-form">
        <el-form :inline="false" :label-position="labelPosition" :ref="ref" :model="form" :rules="rules"
            label-width="140px" size="small">
            <el-row :gutter="24">
                <el-col :span="24">
                    <el-form-item label="作品名称：" prop="goods_name">
                        <el-input :readonly="!is_edit" :style="formStyle" v-model.trim="form.goods_name"
                            style="width: 400px;" clearable placeholder="请输入作品名称" />
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="form.goods_sn">
                    <el-form-item label="作品编号：" prop="goods_sn">
                        {{ form.goods_sn }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="作品主图：" prop="goods_path">
                        <upload-mult :disabled="!is_edit" :name="1" :baseFlag="false" :multiple="false"
                            :posturl="posturl" :limitCount="1" :imgsuffixs="['jpeg', 'jpg', 'png', 'gif', 'bmp']"
                            :preview="true" @addFile="addImage" @filechange="imgChange" :uploadHeader="uploadHeader"
                            :list="syList" :limitSize="10">
                        </upload-mult>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="分类：" prop="cat_id">
                        <treeselect :disabled="!is_edit" :style="formStyle" v-model="form.cat_id" :options="cat_id"
                            :show-count="true" :default-expand-level="1" :clearable="true" placeholder="请选择分类" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="艺术家：" prop="artist_id">
                        <el-select :disabled="!is_edit" popper-class="green-select" :style="formStyle"
                            v-model="form.artist_id" :multiple="false" filterable placeholder="请选择艺术家">
                            <el-option v-for="v in artist_id" :key="v.value" :label="v.label" :value="v.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="24">
                            <el-form-item label="持有人：" prop="holder_id">
                                <el-select v-model="form.holder_id" :multiple="false" filterable  placeholder="请选择持有人">
                                    <el-option
                                        v-for="v in holder_id"
                                        :key="v.value"
                                        :label="v.label"
                                        :value="v.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                <el-col :span="24">
                    <el-form-item label="类型：" prop="goods_type">
                        <el-select :disabled="!is_edit" popper-class="green-select" :style="formStyle"
                            v-model="form.goods_type" :multiple="false" placeholder="请选择类型" @change="changetype"
                            style="width: 400px;">
                            <el-option v-for="v in goods_type" :key="v.value" :label="v.label" :value="v.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col>

                </el-col> -->
                <el-col :span="24" v-for="(v, k) in form.attr">
                    <el-form-item :label="v.attr_name" v-if="v.attr_input_type == '2'">
                        <el-select :disabled="!is_edit" popper-class="green-select" :style="formStyle"
                            v-model="form.attr[k]['value']" :placeholder="'请选择' + v.attr_name" style="width: 400px;">
                            <el-option v-for="vv in form.attr[k]['valuearr']" :key="vv" :label="vv" :value="vv">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="v.attr_name" v-else-if="v.attr_input_type == '1'">
                        <el-input :readonly="!is_edit" :style="formStyle" v-model="form.attr[k]['value']"
                            :placeholder="'请填写' + v.attr_name" style="width: 400px;" clearable />
                    </el-form-item>
                    <el-form-item :label="v.attr_name" v-else-if="v.attr_input_type == '3'">
                        <el-input :readonly="!is_edit" :style="formStyle" v-model="form.attr[k]['value']" clearable
                            :placeholder="'请填写' + v.attr_name" type="textarea" rows="4" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="权属证明：">
                        <upload-mult :disabled="!is_edit" :posturl="fileurl" :name="4" :baseFlag="false"
                            :multiple="true" :limitCount="60" :fileType="[4]"
                            :filesuffixs="['jpeg', 'jpg', 'png', 'gif', 'bmp', 'xlsx', 'xls', 'doc', 'docx', 'pdf']"
                            :preview="true" @addFile="addFile" @fileChange="fileChange" :uploadHeader="uploadHeader"
                            :list="fjList" :limitSize="50">
                        </upload-mult>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="作品描述：">
                        <el-input :readonly="!is_edit" :style="formStyle" :rows="4" type="textarea"
                            v-model.trim="form.goods_desc" style="width: 400px;" clearable placeholder="请输入作品描述" />
                    </el-form-item>
                </el-col>
                <el-col v-if="is_edit" :span="24">
                    <el-row>
                        <el-col :span="12">
                            <div class="form-sub-btn2 vcenter"> <el-button plain class="green curadm"
                                    @click="formSubmit(-1)">保存草稿</el-button>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="form-sub-btn vcenter"> <el-button type="primary" class="green curadm"
                                    @click="formSubmit(0)">确认并提交</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>


            </el-row>
        </el-form>
    </div>
</template>

<script>
import ty from "@/utils/ty/ty";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
const uploadMult = () => import("@/material_component/UploadFiles/index.vue");

let that;
export default {
    name: "indexForm",
    components: {
        Treeselect,
        uploadMult,
    },
    props: {
        is_edit: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            formStyle: {
                width: '700px'
            },
            title: "",
            ref: "form",
            dialogFormVisible: true,
            id: "",
            form: {
                goods_name: '',
                goods_sn: '',
                cat_id: undefined,
                market_price: '',
                goods_desc: '',
                artist_id: '',
                broker_id: '',
                holder_id: '',
                goods_type: '',
                goods_img: '',
                goods_path: '',
                chip_no: '',
                chip_position: '',
                certificate_no: '',
                certificate_name: '',
                certificate_type: '',
                certificate_date: '',
                status: '',
                attr: [],
                fileList: [],
                certificateList: [],
                type: '',
                collectlist: [],
                fjList: [],
                ArtistPhoto: '',
                zip_file: ''
            },
            rules: {
                goods_name: [{ required: true, trigger: "blur", message: "请输入作品名称" }],
                goods_sn: [{ required: true, trigger: "blur", message: "请输入作品编号" }],
                cat_id: [{ required: true, trigger: "blur", message: "请选择分类" }],
                artist_id: [{ required: true, trigger: "blur", message: "请选择艺术家" }],
                holder_id: [{ required: true, trigger: "blur", message: "请选择持有人" }],
                broker_id: [{ required: true, trigger: "blur", message: "请选择经纪人" }],
                goods_type: [{ required: true, trigger: "blur", message: "请选择类型" }],
                goods_path: [{ required: true, trigger: "blur", message: "请上传作品主图" }],
            },
            labelPosition: "right",
            activeName: 'first',
            statusarr: [],
            cat_id: [],
            artist_id: [],
            holder_id: [],
            broker_id: [],
            certificate_type: [],
            goods_type: [],
            attr: [],
            uploadHeader: {},
            fileurl: process.env.VUE_APP_API_ROOT + "web/admin/file/files",
            posturl: process.env.VUE_APP_API_ROOT + "web/admin/file/images",
            fileList: [],
            fjList: [],
            syList: [],
            certificateList: [],
            lines: [],
            third_first: false,
        };
    },
    created() {
        that = this;
        this.uploadHeader = {
            Authorization: "Bearer " + (this.$store.state.token || ''),
        };
        console.log(this.$store.state);
        // setTimeout(() => {
        //     that.$refs[that.ref].resetFields();
        //     that.$refs[that.ref].clearValidate();
        //     console.log(that.$refs[that.ref])
        // }, 3000)
    },
    methods: {
        addFile(fileList) {
            this.fjList = this.fjList ? this.fjList : [];
            this.fjList = fileList;
            console.log("addFile", fileList);
        },
        fileChange(file, fileList) {
            this.fjList = fileList;
        },
        tabchange() {
            if (that.activeName == 'third' && !that.third_first) {
                that.third_first = true;
            }
        },
        changetype() {
            ty.ajax('web/goods/goods/attr', { id: that.form.goods_type }).then((result) => {
                that.form.attr = result.data.data;
            });
        },
        addImage(fileList) {
            if (fileList.length > 0) {
                that.form.goods_img = fileList[0].path;
                that.form.goods_path = fileList[0].url;
            } else {
                that.form.goods_img = "";
                that.form.goods_path = "";
            }
            that.syList = that.form.goods_path ? [{ url: that.form.goods_path }] : []

        },
        imgChange(fileList) {
            if (fileList.length > 0) {
                that.form.goods_img = fileList[0].path;
                that.form.goods_path = fileList[0].url;
            } else {
                that.form.goods_img = "";
                that.form.goods_path = "";
            }
            that.syList = that.form.goods_path ? [{ url: that.form.goods_path }] : []

        },
        addImgs(fileList) {
            this.fileList = fileList;
        },
        addcertificateImgs(fileList) {
            this.certificateList = fileList;
        },
        imgListChange(file, fileList) {
            this.fileList = fileList;
        },
        imgcertificateListChange(file, fileList) {
            this.certificateList = fileList;
        },
        formShow(id) {
            if (!id) {
                that.id = "";
            } else {
                that.id = id;
            }
            ty.ajax('web/goods/goods/detail', { id: that.id }).then((result) => {
                if (result.data.data && that.id > 0) {
                    that.form = result.data.data;
                }
                for (let k in result.data) {
                    that[k] = result.data[k];
                }
                that.syList = that.form.goods_path ? [{ url: that.form.goods_path }] : []
                that.dialogFormVisible = true;
            });
        },
        close() {
            console.log(that.$refs[that.ref])
            that.$refs[that.ref].resetFields();
            that.$refs[that.ref].clearValidate();
            that.form = {
                goods_name: '',
                goods_sn: '',
                cat_id: undefined,
                market_price: '',
                goods_desc: '',
                artist_id: '',
                broker_id: '',
                holder_id: '',
                goods_type: '',
                goods_img: '',
                goods_path: '',
                chip_no: '',
                chip_position: '',
                certificate_no: '',
                certificate_name: '',
                certificate_type: '',
                certificate_date: '',
                status: '',
                attr: [],
                fileList: [],
                certificateList: [],
                type: '',
                collectlist: [],
                ArtistPhoto: '',
                zip_file: ''
            };
            that.fileList = [];
            that.fjList = [];
            that.syList = [];
            that.certificateList = [];
        },
        formSubmit(status) {
            // if (status == -1) {
            //     submit()
            //     return
            // }
            that.$refs[that.ref].validate(async (valid) => {
                if (valid) {
                    submit()
                } else {
                    return false;
                }
            });
            function submit() {
                let url = "";
                if (that.id > 0) {
                    url = "web/goods/goods/update";
                } else {
                    url = "web/goods/goods/create";
                }
                that.form.fileList = that.fileList;
                that.form.certificateList = that.certificateList;
                that.form.status = status
                that.form.fjList = that.fjList;

                ty.ajax(url, that.form).then((result) => {
                    ty.message(result.message, "success");
                    // that.$emit("fetch-data");
                    if (!that.id) {
                        that.close();
                    }
                    that.$emit("fetch-data");

                });
            }
        },
    },
};
</script>
<style lang="scss">
.temp-collect-form {
    .vue-treeselect--focused:not(.vue-treeselect--open) .vue-treeselect__control {
        border-color: #ff0000;
        box-shadow: none;
    }

    .el-input.is-active .el-input__inner,
    .el-input__inner:focus,
    .el-textarea__inner:focus {
        border-color: #418676;
    }

    .el-range-editor.is-active,
    .el-range-editor.is-active:hover,
    .el-select .el-input.is-focus .el-input__inner {
        border-color: #418676;
    }

    .el-select .el-input__inner:focus {
        border-color: #418676;

    }

    .form-sub-btn {
        margin-top: 40px;
        margin-bottom: 20px;

        // margin-right: 70px;
        .el-button.green {
            background-color: $green;
            border-color: $green;
            height: 44px;
            font-size: 17px;
            line-height: 22px;
            border-radius: 5px;
            width: 294px;
        }

        .el-button.green.is-disabled {
            background-color: #2c5a5080;
            border-color: #2c5a5000;
        }

    }

    .form-sub-btn2 {
        margin-top: 40px;
        margin-bottom: 20px;

        // margin-right: 70px;
        .el-button.green {
            color: $green;
            border-color: $green;
            height: 44px;
            font-size: 17px;
            line-height: 22px;
            border-radius: 5px;
            width: 294px;
        }

        .el-button.green.is-disabled {
            // background-color: #2c5a5080;
            border-color: #2c5a5000;
            color: #2c5a5000;
        }

    }

    .avatar-uploader {
        ::v-deep {
            .el-upload {
                border: 1px dashed #d9d9d9 !important;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .el-upload img {
                font-size: 28px;
                color: #8c939d;
                width: 120px;
                height: 120px;
                line-height: 120px;
                text-align: center;
            }
        }
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
}

.green-select {
    .el-select-dropdown__item.selected {
        color: #418676;
    }
}
</style>
